<!-- rel="opener": same-origin page, and keeping the opener lets the browser hand the new window this
     tab's sign-in session, so it opens without bouncing through the login page. -->
<a *ngIf="iconOnly; else pill" class="ais-icon-link" [class.ais-icon-link-stale]="heard && stale" [routerLink]="trackerLink"
  [target]="newWindow ? '_blank' : '_self'" [attr.rel]="newWindow ? 'opener' : null"
  [matTooltip]="tooltip" [attr.aria-label]="ariaLabel">
  <mat-icon aria-hidden="true">my_location</mat-icon>
</a>

<ng-template #pill>
  <a *ngIf="newWindow; else sameWindow" class="ais-link" [class.ais-link-muted]="!mmsi" [routerLink]="trackerLink"
    target="_blank" rel="opener" [matTooltip]="tooltip" [attr.aria-label]="ariaLabel">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    <mat-icon class="ais-new-window" aria-hidden="true">open_in_new</mat-icon>
  </a>
</ng-template>

<ng-template #sameWindow>
  <a class="ais-link" [class.ais-link-muted]="!mmsi" [routerLink]="trackerLink"
    [matTooltip]="tooltip" [attr.aria-label]="ariaLabel">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #content>
  <mat-icon aria-hidden="true">{{mmsi ? 'my_location' : 'location_disabled'}}</mat-icon>
  <span>Locate</span>
  <span *ngIf="heard" class="ais-age" [class.ais-age-stale]="stale">{{age}}</span>
</ng-template>
